var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[(_vm.errorMsg !== '')?_c('code',[_vm._v(" Error: "+_vm._s(_vm.errorMsg)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }